module.exports = __webpack_public_path__ + "img/youtube-brands.4ece9eb9.svg";